/**
 * Dependencies
 */
import { cloneDeep } from 'lodash'

/**
 * Rental income importer modal state
 *
 * @type {Object}
 */
const state = {
    assistanceRequested: false,
    assistanceSuccess: false,
    assistanceMessage: null,
    attemptingImport: false,
    uploaded: false,
    loading: false,
    error: null,
    remapping: false,
    showTab: 0,
    data: {
        date: null,
        file_name: null,
        summary: {},
        table_data: {
            data: [],
            meta: {
                number_of_rows: 0
            }
        }
    },
    meta: {
        rentroll_file_id: null,
        assignment_options: {}
    },
    pagination: {
        currentPage: 1,
        pageLimit: 18
    },
    mapping: {}
}

/**
 * Return a fresh copy of the base state
 *
 * @return {Object}
 */
export const getState = () => cloneDeep(state)

export default getState()



// WEBPACK FOOTER //
// ./src/state/modules/rent-roll-importer/state.js